import cn from 'classnames';
import styles from './Toggle.module.scss';
import { Switch } from '@/atoms/Switch';

type ToggleProps = {
  className?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
};

export function Toggle({
  className,
  checked,
  onChange,
  disabled,
  label,
}: ToggleProps) {
  const wrapperClassName = cn(styles.wrapper, className);

  return (
    <div className={wrapperClassName}>
      <Switch checked={checked} onChange={onChange} disabled={disabled} />
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
}
